export default {
  sizeScreen: () => {
    const size = window.screen.width
    return size
  },
  // baseUrl: () => {
  //   return process.env.BASE_URL
  // },
}